<template>
  <a-modal
    title="通道详情"
    :visible="visible"
    @cancel="handleCancel"
    :footer="null"
    width="800px"
  >
    <a-descriptions :column="2" bordered>
      <a-descriptions-item label="通道ID">
        <a-tag color="green">{{ detailData.channelId }}</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="通道名称">
        <b>{{ detailData.channelName }}</b>
      </a-descriptions-item>
      <a-descriptions-item label="接口代码">
        {{ detailData.ifCode }}
      </a-descriptions-item>
      <a-descriptions-item label="支付方式">
        {{ detailData.wayCode }}
      </a-descriptions-item>
      <a-descriptions-item label="商户费率">
        <a-tag color="blue">{{ detailData.feeRate }}%</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="费用计算方式">
        <a-tag :color="detailData.feeType === 1 ? 'orange' : 'purple'">
          {{ detailData.feeType === 1 ? '百分比' : '固定金额' }}
        </a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="单笔最小金额">
        <span class="amount-text">{{ formatAmount(detailData.minAmount) }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="单笔最大金额">
        <span class="amount-text">{{ formatAmount(detailData.maxAmount) }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="日累计限额">
        <span class="amount-text">{{ formatAmount(detailData.dayMaxAmount) }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="月累计限额">
        <span class="amount-text">{{ formatAmount(detailData.monthMaxAmount) }}</span>
      </a-descriptions-item>
      <a-descriptions-item label="状态">
        <a-badge
          :status="detailData.state === 1 ? 'processing' : 'error'"
          :text="detailData.state === 1 ? '正常' : '禁用'"
        />
      </a-descriptions-item>
      <a-descriptions-item label="排序权重">
        {{ detailData.sortOrder || '--' }}
      </a-descriptions-item>
      <a-descriptions-item label="创建时间" :span="2">
        {{ detailData.createdAt }}
      </a-descriptions-item>
      <a-descriptions-item label="更新时间" :span="2">
        {{ detailData.updatedAt }}
      </a-descriptions-item>
      <a-descriptions-item label="备注信息" :span="2">
        {{ detailData.remark || '--' }}
      </a-descriptions-item>
    </a-descriptions>

    <!-- 通道配置参数 -->
    <a-divider>通道配置参数</a-divider>
    <div v-if="detailData.configParams && Object.keys(detailData.configParams).length > 0">
      <a-descriptions :column="1" bordered>
        <a-descriptions-item
          v-for="(value, key) in detailData.configParams"
          :key="key"
          :label="key"
        >
          <pre>{{ value }}</pre>
        </a-descriptions-item>
      </a-descriptions>
    </div>
    <div v-else class="no-config">
      <a-empty description="暂无配置参数" />
    </div>
  </a-modal>
</template>

<script>
import { formatAmount } from '@/utils/util'

export default {
  name: 'ChannelDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    detailData: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    // 关闭弹窗
    handleCancel () {
      this.$emit('cancel')
    },

    // 格式化金额
    formatAmount
  }
}
</script>

<style lang="less" scoped>
.amount-text {
  font-weight: 500;
  color: #1890ff;
}

.no-config {
  text-align: center;
  padding: 20px;
}

pre {
  white-space: pre-wrap;
  word-break: break-all;
  background-color: #f6f8fa;
  padding: 8px;
  border-radius: 4px;
  margin: 0;
}

.ant-descriptions-item-label {
  font-weight: 500;
}

.ant-descriptions-item-content {
  word-break: break-all;
}
</style>
